import api from "../../../../services/api";

export const fetchUserProfile = () => api.get("/vendor/tokenUser");

// to call api without headers call the api as  api.get("/vendor/tokenUser",{headers:{}});
